<template>
  <div class="c-serviceWidgetItem c-serviceWidgetItemBlock">
    <div class="c-serviceWidgetItem_inner c-serviceWidgetItemRow c-serviceWidgetItemBlock_inner">
      <div
        class="c-serviceWidgetItemRow_pro"
        v-if="service.proServiceFlag"
      >
        <ProIcon
          is-outlined
          width="32px"
          v-if="isPC"
        />
        <ProIcon
          is-outlined
          width="24px"
          v-if="isTB || isSP"
        />
      </div>

      <div class="c-serviceWidgetItemRow_image">
        <img
          :src="$coconala.serviceImageURL(service.serviceImage)"
          alt=""
          class="c-serviceWidgetItemImage"
          loading="lazy"
          decoding="async"
        >

        <div class="c-serviceWidgetItemRow_labels">
          <div
            class="c-serviceWidgetItemRowLabel c-serviceWidgetItemRowLabel-limit"
            v-if="service.fullCorrespondenceFlag"
          >
            <div class="c-serviceWidgetItemRowLabel_label">満枠対応中</div>
          </div>
          <div
            class="c-serviceWidgetItemRowLabel c-serviceWidgetItemRowLabel-stop"
            v-else-if="service.stopFg"
          >
            <div class="c-serviceWidgetItemRowLabel_label">受付休止中</div>
          </div>
        </div>
      </div>

      <div class="c-serviceWidgetItemRow_flag">
        <img
          src="@/assets/images/common/icon-video-service.svg"
          alt=""
          loading="lazy"
          decoding="async"
          v-if="service.videoType === VIDEO_TYPE"
        />
        <img
          src="@/assets/images/common/icon-phone-service.svg"
          alt=""
          loading="lazy"
          decoding="async"
          v-if="service.serviceClass === SERVICE_CLASS_PHONE"
        />
      </div>

      <div class="c-serviceWidgetItemRow_content c-serviceWidgetItemContent">
        <div class="c-serviceWidgetItemContent_header c-serviceWidgetItemContentHeader">
          <div
            class="c-serviceWidgetItemContent_title"
            v-if="service.overview"
          >
            <p class="c-serviceWidgetItemContent_overview">
              {{ serviceName }}
            </p>
            <h3 class="c-serviceWidgetItemContent_catchphrase">
              {{ service.catchphrase }}
            </h3>
          </div>
          <div
            class="c-serviceWidgetItemContent_title"
            v-else
          >
            <h3 class="c-serviceWidgetItemContent_name">
              {{ serviceName }}
            </h3>
          </div>
        </div>

        <div class="c-serviceWidgetItemContent_footer c-serviceWidgetItemContentFooter">
          <div class="c-serviceWidgetItemContent_infoUser c-serviceWidgetItemContentInfoUser">
            <div class="c-serviceWidgetItemContentInfoUser_icon">
              <CUserIconV2
                :file-path="service.provider.profileIconPath"
                :size="20"
                :width="40"
                :height="40"
                v-if="isPC"
              />
              <CUserIconV2
                :file-path="service.provider.profileIconPath"
                :size="16"
                :width="32"
                :height="32"
                v-else-if="isSP || isTB"
              />
            </div>
            <div class="c-serviceWidgetItemContentInfoUser_name">
              <span>{{ service.provider.name }}</span>
            </div>
            <div class="c-serviceWidgetItemContentInfoUser_level">
              <img
                :src="$coconala.levelIconURL(service.provider.level)"
                alt=""
                loading="lazy"
                decoding="async"
                v-if="service.provider.level > 0"
              >
            </div>
          </div>

          <div class="c-serviceWidgetItemContent_price c-serviceWidgetItemContentPrice">
            <div class="c-serviceWidgetItemContentPrice_rating">
              <span
                class="c-serviceWidgetItemContentPriceRating"
                v-if="service.rating.indicator"
              >
                <CoconalaIcon
                  name="star"
                  class="c-serviceWidgetItemContentPriceRating_star"
                />
                <span class="c-serviceWidgetItemContentPriceRating_score">
                  {{ service.rating.indicator.toFixed(1) }}
                </span>
              </span>
              <span v-else>
                <CoconalaIcon
                  name="star"
                  class="c-serviceWidgetItemContentPriceRating_star"
                /> -
              </span>

              <span
                class="c-serviceWidgetItemContentPriceRating_count"
                v-if="service.performanceCount > 0"
              >({{ service.performanceCount }})
              </span>
            </div>

            <div class="c-serviceWidgetItemContentPrice_price">
              <div v-if="service.serviceClass === SERVICE_CLASS_PHONE">
                <strong>{{ $util.numberWithDelimiter(service.priceWot) }}</strong>円<span class="c-serviceWidgetItemContentPrice_unit">/分</span>
              </div>
              <div v-else-if="service.unitTime">
                <strong>{{ $util.numberWithDelimiter(service.priceWot) }}</strong>円<span class="c-serviceWidgetItemContentPrice_unit">/{{ $util.numberWithDelimiter(service.unitTime) }}分</span>
              </div>
              <div v-else>
                <strong>{{ $util.numberWithDelimiter(service.priceWot) }}</strong>円
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isLoggedIn && (isPC || isTB || isSP)"
      class="c-serviceWidgetItemRow_favButton"
    >
      <FavButtonV2
        :is-favorited="service.isFavorited"
        :service-id="service.id"
      />
    </div>
  </div>
</template>
<script>
import FavButtonV2 from '~/components/molecules/buttons/FavButtonV2'
import ProIcon from '~/components/molecules/ProIcon'
import { mapGetters } from 'vuex'

const SERVICE_CLASS_PHONE = 1
const VIDEO_TYPE = 2
/** 画像領域の高さ比率 */

export default {
  name: 'ServiceWidgetItem',
  components: {
    FavButtonV2,
    ProIcon
  },
  props: {
    service: {
      type: Object
    }
  },
  data() {
    return {
      SERVICE_CLASS_PHONE,
      VIDEO_TYPE,
      disabledLinkEffect: true
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    serviceName() {
      if (this.service.overview) {
        return this.service.overview
      }
      return this.service.name
    }
  }
}
</script>
<style lang="scss" scoped>
.c-serviceWidgetItemBlock {
  position: relative;
  background-color: $color-white;
  color: $color-gray-900;

  &_inner {
    position: relative;
    min-height: 304px;
    border: 1px solid $color-gray-200;

    &:hover {
      /deep/ .c-favButtonWrapper {
        display: block;
      }
    }
  }
}

.c-serviceWidgetItemRow {
  @include link-effect;

  &_image {
    position: relative;
    width: 230px;
    height: 190px;
  }

  &_pro {
    position: absolute;
    top: -3px;
    left: 10px;
    z-index: 10;
    width: 32px;
  }

  &_favButton {
    position: absolute;
    right: 8px;
    bottom: 130px;
  }

  &_labels {
    position: absolute;
    bottom: 0;
    left: -1px;
    z-index: 10;
    width: 232px;
  }

  &_flag {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    width: 36px;
    height: 36px;

    img {
      width: 36px;
      height: 36px;
    }
  }

  &_content {
    position: relative;
    padding: 8px 10px;
  }
}

.c-serviceWidgetItemImage {
  position: relative;
  width: 100%;
  height: 100%;
}

.c-serviceWidgetItemContent {
  &_title {
    overflow: hidden;
    height: 38px;
    color: $color-gray-900;
    font-weight: normal;
    font-size: 14px;
    line-height: 1.5;
  }
}

.c-serviceWidgetItemContentInfoUser {
  position: relative;
  z-index: 10;
  display: flex;
  margin-top: 12px;

  &_icon {
    overflow: hidden;
    margin-right: 4px;
    width: 20px;
    height: 22px;

    flex-basis: 20px;

    img {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }
  }

  &_name {
    span {
      display: inline-block;
      overflow: hidden;
      margin-left: 2px;
      max-width: 140px;
      height: 20px;
      color: $color-gray-600;
      vertical-align: middle;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 10px;
    }
  }

  &_level {
    position: relative;
    margin-left: 12px;

    img {
      height: 20px;
    }
  }
}

.c-serviceWidgetItemRowLabel {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 21px;

  align-items: center;
  justify-content: center;

  &-standby {
    background: $color-orange-600;
    color: $color-white;
  }

  &-busy {
    background: $color-deep-blue-500;
    color: $color-white;
  }

  &-away {
    background: $color-gray-200;
    color: $color-gray-700;
  }

  &-reserve {
    border: solid 1px $color-orange-600;
    background: $color-white;
    color: $color-orange-600;
  }

  &-limit {
    background: $color-red-400;
    color: $color-white;
  }

  &-stop {
    background: $color-gray-200;
    color: $color-gray-700;
  }

  &_label {
    font-size: 12px;
    line-height: 12px;
  }
}

.c-serviceWidgetItemContentPrice {
  position: relative;
  z-index: 10;
  display: flex;

  justify-content: space-between;

  &_rating {
    padding-top: 4px;
  }

  &_price {
    color: $color-gray-900;
    font-size: 12px;

    strong {
      padding-right: 2px;
      font-weight: normal;
      font-size: 17px;
    }
  }
}

.c-serviceWidgetItemContentPriceRating {
  display: inline-block;
  height: 21px;
  color: $color-gray-700;
  font-size: 13px;

  &_star {
    color: $color-yellow-500;
    vertical-align: -1px;
    font-size: 12px;
  }

  &_score {
    color: $color-yellow-500;
  }

  &_count {
    margin-right: 5px;
    color: $color-gray-600;
    font-size: 11px;
  }
}

@media (min-width: breakpoint(630px)) {
  .c-serviceWidgetItemBlock {
    width: 232px;

    flex-basis: 232px;
  }
}

@media (max-width: breakpoint(630px)) {
  .c-serviceWidgetItemBlock {
    width: auto;

    flex-basis: 100%;
  }

  .c-serviceWidgetItemRow {
    &_image {
      position: relative;
      min-height: 121px;
      width: 100%;
      height: inherit;
    }

    &_pro {
      position: absolute;
      top: -3px;
      left: 4px;
      z-index: 10;
      width: 24px;
    }

    &_labels {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }

    &_flag {
    }

    &_content {
      position: relative;
      padding: 4px 8px;
    }
  }

  .c-serviceWidgetItemImage {
    img {
      width: 100%;
      height: auto;
    }
  }

  .c-serviceWidgetItemContent {
    &_title {
      overflow: hidden;
      // SPでは2行表示させたいため1.5(line-height分) x 2
      height: 3em;
      font-weight: normal;
      font-size: 12px;

      p {
        margin-bottom: 0;
      }
    }
  }

  .c-serviceWidgetItemContentInfoUser {
    overflow: hidden;
    margin-top: 6px;
    height: 20px;

    &_icon {
      margin-right: 4px;

      flex-basis: 16px;

      img {
        width: 16px;
        height: 16px;
        border-radius: 50%;
      }
    }

    &_name {
      span {
        max-width: 80px;
        vertical-align: baseline;
      }
    }

    &_level {
      position: relative;
      margin-left: 12px;

      img {
        height: 16px;
      }
    }
  }

  .c-serviceWidgetItemRowLabel {
    height: 16px;

    &_label {
      font-size: 11px;
      line-height: 12px;
    }
  }

  .c-serviceWidgetItemContentPrice {
    &_rating {
      padding-top: 0;
      text-align: left;
    }

    &_price {
      flex: 2;
      text-align: right;
      font-size: 12px;

      strong {
        font-size: 14px;
      }
    }

    &_unit {
      display: inline-block;
    }
  }

  .c-serviceWidgetItemContentPriceRating {
    height: auto;
    font-size: 12px;

    &_count {
      font-size: 12px;
    }
  }
}

@media (max-width: breakpoint(630px)) {
  .c-serviceWidgetItemBlock {
    &_inner {
      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
